import { Dropdown, Col, Row, Space, Typography, Modal, Button, message } from "antd";
import { useState } from "react";
import BundlesFormDialog from "../components/bundles/BundlesFormDialog";
import { Guid } from "guid-typescript";
import { SearchQuery } from "../code/search-query/search-query";
import { getBundlesExport } from "../repository/data.repository";
import Loader from "../controls/Loader";
import { useSelector } from "../store/store";
import { authorizeSelectors } from "../store/authorize";
import BundlesView from "../components/bundles/BundlesView";
import { Bundle } from "../repository/data.default";
import { getProblemMessage } from "../utils/http";

function BundlesPage() {
  const [modal, contextHolder] = Modal.useModal();
  const [searchQuery, setSearchQuery] = useState<SearchQuery>({
    conditions: [],
  });
  const [bundleInputMode, setBundleInputMode] = useState<
    "add" | "update" | "delete"
  >("add");
  const [bundleInputOpen, setBundleInputOpen] = useState(false);
  const [bundleInputValues, setBundleInputValues] = useState<Bundle>({} as any);
  const [triggerView, setTriggerView] = useState(Guid.create().toString());
  const permissions = useSelector(authorizeSelectors.permissions);

  function onSearch(searchQuery: SearchQuery): void {
    setSearchQuery(searchQuery);
  }

  function onBundleInputOpen(
    mode: "add" | "update" | "delete",
    values?: Bundle,
  ): void {
    setBundleInputMode(mode);
    setBundleInputOpen(true);
    setBundleInputValues(values || ({} as any));
  }

  function onBundleInputFinish(): void {
    setBundleInputOpen(false);
    setBundleInputValues({} as any);
    setTriggerView(Guid.create().toString());
  }

  function onBundleInputClose(): void {
    setBundleInputOpen(false);
    setBundleInputValues({} as any);
  }

  function onDownloadExport(): void {
    const loading = modal.info({
      content: (
        <Typography.Text className="m-1 ml-2 inline-block">
          Downloading bundles export file..
        </Typography.Text>
      ),
      footer: null,
      centered: true,
      icon: <Loader />,
    });
    getBundlesExport({
      searchQuery,
      pageNumber: 0,
      pageSize: Number.MAX_SAFE_INTEGER,
    })
      .then(() => {
        loading.destroy();
      })
      .catch((err) => {
        loading.destroy();
        message.error(getProblemMessage(err) || "Failed to download export.");
      });
  }

  return (
    <Col className="relative flex flex-auto flex-col overflow-hidden overflow-y-auto">
      <Row className="sticky top-0 z-10 flex flex-row flex-wrap items-center p-4">
        <Typography.Title className="m-0 flex-auto" level={4}>
          Test Bundles
        </Typography.Title>
        <Space className="flex flex-row">
          <Dropdown.Button
            type="primary"
            disabled={!permissions.can("Bundles", "create")}

            className={`${!permissions.can("Bundles", "create") ? "disabled" : ""}`}
            menu={{
              items: [
                {
                  key: "downloadExport",
                  label: "Export to Excel",
                  disabled: !permissions.can("Bundles", "view"),
                  onClick: onDownloadExport,
                },
              ],
            }}
            onClick={() => onBundleInputOpen("add")}
          >
            Add Bundle
          </Dropdown.Button>
        </Space>
      </Row>
      <Col className="flex flex-auto flex-col overflow-hidden p-4 pb-4 pt-0">
        <BundlesView
          trigger={triggerView}
          onAction={(key: string, record: any) =>
            onBundleInputOpen(key as any, record)
          }
          onSearch={onSearch}
        />
      </Col>
      <BundlesFormDialog
        key={bundleInputMode}
        mode={bundleInputMode}
        open={bundleInputOpen}
        initialValues={bundleInputValues}
        onFinish={onBundleInputFinish}
        onCancel={onBundleInputClose}
      />
      {contextHolder}
    </Col>
  );
}

export default BundlesPage;
